
import { Helpers } from '@bode-canada/core';
import Icon from '@/ui-kit/components/icon';
import Typography from '@/ui-kit/components/typography';
import Button from '@/ui-kit/components/button';
import { IconProperty, IconType } from '@/ui-kit/components/icon/enums';
import {
  StyleSizeType,
  StyleColorSchemeType,
  StyleFontWeightType,
} from '@/ui-kit/styles/enums';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import { MarketDataEvent } from '@/constants/AnalyticEvents';
import { QueryParams } from '@/constants/QueryParams';

export default {
  name: 'MarketDataFooter',
  components: {
    Icon,
    Typography,
    Button,
  },
  data() {
    return {
      IconType,
      IconProperty,
      TypographyType,
      TypographyProperty,
      StyleColorSchemeType,
      StyleSizeType,
      StyleFontWeightType,
      ButtonProperty,
      ButtonPropsEventType,
    };
  },
  methods: {
    handleBrowseSoldDataClick() {
      this.$track(MarketDataEvent.BrowseSoldData);
      // Pass filters params to sold data page
      const { query } = this.$route;
      const searchParams = new URLSearchParams({
        [QueryParams.City]: query[QueryParams.City],
        [QueryParams.TransactionDate]: query[QueryParams.TransactionDate],
        ...Helpers.ObjectHelper.removeEmptyProperties({
          [QueryParams.Community]: query[QueryParams.Community]?.split(',')[0],
        }),
      });

      this.$router.push(`/sold-data?${searchParams.toString()}`);
    },
  },
};
